import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Form } from 'foundations-components/transitional/components/Form';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class TwoFactorRecoveryAdminRecoverForm extends Component {
  constructor(...args) {
    super(...args);
    this.renderRecoveryButton = () => {
      const {
        isAdminRecoveryErrorAlertVisible,
        isAdminRecoveryRequesting
      } = this.props;
      return /*#__PURE__*/_jsx(LoadingButton, {
        block: true,
        use: "primary",
        type: "submit",
        disabled: isAdminRecoveryErrorAlertVisible,
        loading: isAdminRecoveryRequesting,
        children: I18n.text('login.twoFactor.admin.form.recoverButton')
      });
    };
    this.renderInvalidCodeAlert = () => {
      const {
        isInvalidRecoveryCodeAlertVisible,
        hideInvalidRecoveryCodeAlert
      } = this.props;
      if (!isInvalidRecoveryCodeAlertVisible) {
        return null;
      }
      return /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        titleText: I18n.text('login.twoFactor.errors.invalidCode.title'),
        closeable: true,
        onClose: hideInvalidRecoveryCodeAlert,
        children: I18n.text('login.twoFactor.errors.invalidCode.body')
      });
    };
    this.renderErrorAlert = () => {
      const {
        isAdminRecoveryErrorAlertVisible
      } = this.props;
      if (isAdminRecoveryErrorAlertVisible) {
        return /*#__PURE__*/_jsx(Alert, {
          type: "danger",
          children: I18n.text('login.twoFactor.admin.error.errorText')
        });
      }
      return null;
    };
    this.renderLoadingScreen = () => {
      return /*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        paddingBlockStart: "200",
        children: [/*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          minHeight: 100
        }), /*#__PURE__*/_jsx("h1", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `login.loading.default`
          })
        })]
      });
    };
    this.renderAlreadyProcessedScreen = () => {
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h1", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.twoFactor.admin.alreadyProcessedForm.header"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.twoFactor.admin.alreadyProcessedForm.description"
            })
          })]
        })
      });
    };
    this.renderTokenExpiredScreen = () => {
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Text, {
          textAlign: "center",
          children: [/*#__PURE__*/_jsx(Illustration, {
            height: 150,
            name: "errors/general"
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "400"
          }), /*#__PURE__*/_jsx("h1", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "login.twoFactor.admin.expiredToken.header"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "login.twoFactor.admin.expiredToken.description"
            })
          })]
        })
      });
    };
    this.renderInvalidTokenScreen = () => {
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Text, {
          textAlign: "center",
          children: [/*#__PURE__*/_jsx(Illustration, {
            height: 150,
            name: "errors/general"
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "400"
          }), /*#__PURE__*/_jsx("h1", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "login.twoFactor.admin.invalidToken.header"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "login.twoFactor.admin.invalidToken.description"
            })
          })]
        })
      });
    };
    this.renderSuccess = () => {
      const {
        accountEmailToRecover
      } = this.props;
      return /*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.admin.success.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.twoFactor.admin.success.description",
            options: {
              email: accountEmailToRecover
            }
          })
        })]
      });
    };
    this.renderForm = () => {
      const {
        onCodeChange,
        recoveryCode,
        accountEmailToRecover
      } = this.props;
      return /*#__PURE__*/_jsxs(Form, {
        onSubmit: this.props.onSubmit,
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            textAlign: "center",
            as: "h1",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "login.twoFactor.admin.header",
              options: {
                userEmail: accountEmailToRecover
              }
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "login.twoFactor.admin.form.description",
              options: {
                userEmail: accountEmailToRecover
              }
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.twoFactor.admin.form.descriptionMore"
            })
          })]
        }), /*#__PURE__*/_jsx(FormControl, {
          label: I18n.text('login.twoFactor.admin.form.codeInput'),
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(TextInput, {
            "data-test-id": "admin-recovery-code-input",
            id: "code",
            onChange: onCodeChange,
            value: recoveryCode
          })
        }), this.renderInvalidCodeAlert(), this.renderErrorAlert(), this.renderRecoveryButton()]
      });
    };
  }
  render() {
    const {
      hasLoadedAccountEmailToRecover,
      hasRemovalAlreadyBeenProcessed,
      hasAdminRecoveryTokenExpired,
      didAdminRecoverySucceed,
      isAdminRecoveryTokenInvalid
    } = this.props;
    if (!hasLoadedAccountEmailToRecover) {
      return this.renderLoadingScreen();
    }
    if (hasRemovalAlreadyBeenProcessed) {
      return this.renderAlreadyProcessedScreen();
    }
    if (isAdminRecoveryTokenInvalid) {
      return this.renderInvalidTokenScreen();
    }
    if (hasAdminRecoveryTokenExpired) {
      return this.renderTokenExpiredScreen();
    }
    if (didAdminRecoverySucceed) {
      return this.renderSuccess();
    }
    return this.renderForm();
  }
}
TwoFactorRecoveryAdminRecoverForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCodeChange: PropTypes.func.isRequired,
  recoveryCode: PropTypes.string.isRequired,
  isInvalidRecoveryCodeAlertVisible: PropTypes.bool.isRequired,
  hideInvalidRecoveryCodeAlert: PropTypes.func.isRequired,
  accountEmailToRecover: PropTypes.string.isRequired,
  hasLoadedAccountEmailToRecover: PropTypes.bool.isRequired,
  isAdminRecoveryErrorAlertVisible: PropTypes.bool.isRequired,
  hasRemovalAlreadyBeenProcessed: PropTypes.bool.isRequired,
  isAdminRecoveryRequesting: PropTypes.bool.isRequired,
  didAdminRecoverySucceed: PropTypes.bool.isRequired,
  hasAdminRecoveryTokenExpired: PropTypes.bool.isRequired,
  isAdminRecoveryTokenInvalid: PropTypes.bool.isRequired
};